import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=4f9b48a7&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"
import style0 from "./Resources.vue?vue&type=style&index=0&id=4f9b48a7&prod&lang=scss&scoped=true"
import style1 from "./Resources.vue?vue&type=style&index=1&id=4f9b48a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b48a7",
  null
  
)

export default component.exports